/**
 * KeySection — composes the three key panels: Security, Mall Department, Contractors.
 *
 * Replaces the legacy KeyPanel inside EquipmentPanel.tsx.
 */
import { PanelSection } from '../ui'
import { useDesktopStore } from '../../stores/desktop'
import { markDirty } from '../../stores/sync'
import type { SecurityKey, OtherKey } from '../../stores/desktop'
import SecurityKeyCard from './SecurityKeyCard'
import OtherKeyCard from './OtherKeyCard'

export default function KeySection() {
  const { securityKeys, setSecurityKeys, otherKeys, setOtherKeys } = useDesktopStore()

  function updateSec(idx: number, patch: Partial<SecurityKey>) {
    markDirty()
    setSecurityKeys(securityKeys.map((k, i) => (i === idx ? { ...k, ...patch } : k)))
  }

  function updateOther(num: number, patch: Partial<OtherKey>) {
    markDirty()
    setOtherKeys(otherKeys.map(k => (k.number === num ? { ...k, ...patch } : k)))
  }

  const mallKeys       = otherKeys.filter(k => k.category === 'Mall Department')
  const contractorKeys = otherKeys.filter(k => k.category === 'Contractors')

  return (
    <>
      <PanelSection title="Security Keys">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
          {securityKeys.map((k, i) => (
            <SecurityKeyCard key={k.number} k={k} onUpdate={patch => updateSec(i, patch)} />
          ))}
        </div>
      </PanelSection>

      <PanelSection title="Other Keys — Mall Department">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
          {mallKeys.map(k => (
            <OtherKeyCard key={k.number} k={k} onUpdate={patch => updateOther(k.number, patch)} />
          ))}
        </div>
      </PanelSection>

      <PanelSection title="Other Keys — Contractors">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
          {contractorKeys.map(k => (
            <OtherKeyCard key={k.number} k={k} onUpdate={patch => updateOther(k.number, patch)} />
          ))}
        </div>
      </PanelSection>
    </>
  )
}
